import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { patternfirstNamechiffre, patternEmail, linkedInRegExp } from '@core/models/pattern';
import { ConsultantSelectedService } from '@core/services/esn-consultant/consultant-selected.service';
import { EsnConsultantService } from '@core/services/esn-consultant/esn-consultant.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-update-consultant',
  templateUrl: './update-consultant.component.html',
  styleUrls: ['./update-consultant.component.css']
})
export class UpdateConsultantComponent {
formconsultant: FormGroup = this.formBuilder.group({});

    isexistemail = false;
    iscv:boolean=false
    isButtonDisabled: boolean = false;
    isvalid: boolean = false;
    isnull: boolean = false;
    testclient:boolean=false;
    clientSelected: boolean = false;

    errorMessage: string = '';
    errorMessageprofil: string = '';
    fileName: string = '';
    fileError: string = '';
    fileExtention: string = '';

    selectedconsultant: any;
    candidat_id: any;
    company_name: any;
    file: any = '';
    listclient: { id: number; name: string; uuid: string }[] = [];
    client: any[] = [];
    clientList : any[] = [];
    listmanager: {
      uuid: string; id: number; full_name: string, first_name: string, last_name: string 
    }[] = [];
  selectedConsultant: any;
  isInterType: any;
  isUpdatedCV: boolean = false;
    constructor (
      private formBuilder: FormBuilder,
      private esnconsultantservice: EsnConsultantService,
      private router: Router,
      private toastrService: ToastrService,
      private spinner: NgxSpinnerService,
      private consultantSelectedService : ConsultantSelectedService,
      private activatedRoute: ActivatedRoute,
      private primengConfig: PrimeNGConfig,
        ) {
          this.primengConfig.setTranslation({
            dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
            dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
            dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
            monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
            monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
            today: 'Aujourd\'hui',
            clear: 'Effacer'
          });
    }

    ngOnInit(): void {
      if (this.consultantSelectedService.hasConsultantSelected()) {
        this.selectedConsultant = this.consultantSelectedService.getConsultantSelected()
        console.log('selectedConsultant', this.selectedConsultant);
        if(this.selectedConsultant?.cv){
          this.fileName = this.selectedConsultant.cv
        }
        
        this.activatedRoute.paramMap.subscribe({
          next: (params: any) => {
            params.params['type'] ? this.isInterType = true : this.isInterType = false;
          },
          error: (err) => {
          },
        });
        this.initializeConsultantForm()
      }
      else{
        this.router.navigateByUrl('/consultants');
      }  
      this.getListclient();
      this.getListmanager();
      
    }

    getListmanager() {
      this.esnconsultantservice.getmanagernew().subscribe({
        next: (response) => {
          if (response.data) {
            this.listmanager = response.data.map((el: any) => {
              return {
                ...el,
                full_name: `${el.first_name} ${el.last_name}`
              };
            });
          }
        },
        error: (error) => {
        },
      });
    }

    getListclient() {
      this.spinner.show();
      this.esnconsultantservice.getclient().subscribe({
        next: (response) => {
          if (response.data) {
            this.listclient = response.data;
            this.client = response.data;
            this.clientList = this.client.map(item=> item.name);
            this.spinner.hide();
          }
        },
        error: (error) => {
          this.spinner.hide();
        },
      });
    }

    createconsultantForm(data?: any) {
        return this.formBuilder.group(
          {
            first_name: [
              data?.first_name || '',
              [Validators.required, Validators.pattern(patternfirstNamechiffre)],
            ],
            last_name: [
              data?.last_name || '',
              [Validators.required, Validators.pattern(patternfirstNamechiffre)],
            ],
            emailProESN: [
              data?.emailProESN || '',
              [Validators.pattern(patternEmail)],
            ],
            email: [
              data?.email || '',
              [Validators.required, Validators.pattern(patternEmail)],
            ],
            linkedin_link: [data?.linkedin_link || ''],
            cv: [data?.cv || ''],
            desired_workstation: [data?.desired_workstation || ''],
            date_signature_contrat: [data?.date_signature_contrat || ''],
            salary: [data?.salary || null],
            tjm_achat: [data?.tjm_achat || ''],
            tjm_vente: [data?.tjm_vente || ''],
            manager_id: [data?.manager_id || null],
            client_id: [data?.client_id?data?.client_id:data?.client_id2 || null],
            candidate_id: [data?.candidate_id || ''],
            mission_start_date: [{ value: '', disabled: true }],
            mission_end_date: [{ value: '', disabled: true }],
            mobility: [data?.mobility || []],
            desired_contract: [data?.desired_contract || []],
            softSkills: [data?.softSkills || []],
            destination_country: [data?.destination_country || []],
            contract_type: [data?.contract_type || []],
            skills_text: [data?.skills_text || []],
          },
          { validator: this.dateRangeValidator }
        );
      }

      dateRangeValidator(
          control: AbstractControl
        ): { [key: string]: boolean } | null {
          const startDate = control.get('mission_start_date')!.value;
          const endDate = control.get('mission_end_date')!.value;
      
          if (startDate && endDate && startDate > endDate) {
            return { dateRangeInvalid: true };
          }
      
          return null;
        }
  
        getconsultantByEmail(event: any) {
          this.errorMessage = '';
          //this.formconsultant.reset();
          const enteredEmail = event.target.value.trim();
      
          if (enteredEmail === '') {
            this.enableFormFields();
            this.formconsultant.get('linkedin_link')?.enable();
            this.selectedconsultant = '';
            this.formconsultant.patchValue({
              first_name: '',
              last_name: '',
              linkedin_link: '',
              cvName: '',
              desired_workstation: '',
            });
            this.isexistemail = false;
            this.isButtonDisabled = false;
            this.errorMessage = '';
            return;
          }
      
          this.esnconsultantservice
            .getconsultantbyemail(enteredEmail)
            .subscribe({
              next: (res: any) => {
                if (res.status === 200) {
                  this.isexistemail = true;
                  if(res.data.cv && res.data.cv!=='null'){
                    this.iscv=true
                    this.fileName = res.data.cv;
                   }
                   else{
                    this.fileName = '';
                    this.iscv=false
                   }
      
                  this.formconsultant.get('linkedin_link')?.enable();
                  this.company_name = res.company_name;
                  this.selectedconsultant = res.data.cv;
                  this.candidat_id = res.data.uuid;
                  if (enteredEmail !== res.data.email) {
                    this.formconsultant.get('linkedin_link')?.enable();
                    this.formconsultant.patchValue({
                      first_name: '',
                      last_name: '',
                      selectedconsultant: '',
                      desired_workstation: '',
                    });
                    this.isexistemail = false;
                    this.isButtonDisabled = false;
                    this.errorMessage = '';
                    return;
                  }
      
                  this.formconsultant.patchValue({
                    email: res.data.email,
                    first_name: res.data.first_name,
                    last_name: res.data.last_name,
                    linkedin_link: res.data.linkedin_link,
                    cv: res.data.cv,
                    desired_workstation: res.data.desired_workstation,
                    client_name: res.client_name,
                  });
                  if (res.data.cv) {
                    this.file = { name: res.data.cv };
                  }
      
                  this.errorMessage = '';
                  this.isButtonDisabled = false;
      
                  if (
                    res.data.linkedin_link !== null &&
                    res.data.linkedin_link !== ''
                  ) {
                    this.formconsultant.get('linkedin_link')?.disable();
                  } else {
                    this.formconsultant.get('linkedin_link')?.enable();
                  }
      
                  this.disableFormFields();
                } else {
                  this.isexistemail = true;
      
                  this.isButtonDisabled = true;
                  this.errorMessage = '"Utilisateur associé à une autre ESN."';
                }
              },
              error: (error: any) => {
                this.isexistemail = false;
                this.iscv=false
                this.enableFormFields()
                this.formconsultant.patchValue({
                  first_name: '',
                  last_name: '',
                  selectedconsultant: '',
                  desired_workstation: '',
                  cv:'',
                  linkedin_link:'',
                });
                if (
                  error?.error?.message === 'User already associated with this ESN'
                ) {
                  this.isexistemail = true;
                  this.isButtonDisabled = true;
                  this.errorMessage = '"Utilisateur associé à cet ESN."';
                }
                if (error?.error?.message === 'User associated with another ESN') {
                  this.isexistemail = true;
                  this.isButtonDisabled = true;
                  this.errorMessage = '"Utilisateur associé à une autre ESN."';
                }
                if (error?.error?.message === 'User profile was not completed') {
                  this.isexistemail = true;
                  this.isButtonDisabled = true;
                  this.errorMessageprofil = '"Le profil utilisateur n\'a pas été complété"';
                }
              },
            });
          if (
            this.formconsultant.value.linkedin_link === undefined &&
            this.formconsultant.value.cv === undefined &&
            this.formconsultant.value.cv !== null &&
            this.formconsultant.value.linkedin_link !== null
          ) {
            this.isvalid = true;
          } else {
            this.isvalid = false;
          }
        }

        enableFormFields() {
          if (this.formconsultant) {
            this.formconsultant.get('first_name')?.enable();
            this.formconsultant.get('last_name')?.enable();
            this.formconsultant.get('emailProESN')?.enable();
            this.formconsultant.get('linkedin_link')?.enable();
            this.formconsultant.get('desired_workstation')?.enable();
            this.formconsultant.get('cv')?.enable();
          }
        }

        disableFormFields() {
          if (this.formconsultant) {
            this.formconsultant.get('first_name')?.disable();
            this.formconsultant.get('last_name')?.disable();
          }
        }

      setValidatorRequirements() {
          const linkedinControl = this.formconsultant.get('linkedin_link');
          const cvControl = this.formconsultant.get('cv');
      
          // Effacer les validateurs existants
          linkedinControl?.clearValidators();
          cvControl?.clearValidators();
      
          if (!linkedinControl?.value && !cvControl?.value) {
            linkedinControl?.setValidators([
              Validators.pattern(linkedInRegExp),
            ]);
          } else {
            if (linkedinControl?.value) {
              linkedinControl?.setValidators([Validators.pattern(linkedInRegExp)]);
            }
            if (cvControl?.value) {
              cvControl?.clearValidators();
              // linkedinControl?.clearValidators();
            }
          }
      
          linkedinControl?.updateValueAndValidity({ emitEvent: false });
          cvControl?.updateValueAndValidity({ emitEvent: false });
        }

      uploadFile(event: any) {
        this.file = event.target.files[0];
        const maxSize = 2 * 1024 * 1024;
        this.fileName = this.file.name;
        if (this.file) {
          const allowedExtensions = ['.pdf', '.docx', '.doc'];
          const fileExtension = this.file.name
            .toLowerCase()
            .substr(this.file.name.lastIndexOf('.'));

          if (!allowedExtensions.includes(fileExtension)) {
            this.fileExtention = 'Format fichier non compatible !';
          } else if (this.file.size > maxSize) {
            this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
          } else {
            this.fileError = '';
            this.fileExtention = '';
          }
           this.isUpdatedCV = true
        }
        this.formconsultant.get('cv')?.setValue(this.file);
      }

      resetCV() {
        const inputFile = document.getElementById('cv') as HTMLInputElement;
        if (inputFile) {
          inputFile.value = '';
          this.fileExtention = '';
          this.fileError = '';
          this.isvalid = true;
        }
        this.fileName = '';
        this.formconsultant.get('cv')?.patchValue(null);
        this.file = null;
        this.isUpdatedCV = true
      }

      isDateRangeValid(): boolean {
        return !this.formconsultant.hasError('dateRangeInvalid');
      }

      /* go to suggestion job request */
      navigateToListConsultant() {
        this.router.navigate(['/consultants',]);
      }

      updateConsultant() {
        this.spinner.show();
        const updatedValues: any = {};
    
        // Convertir les valeurs en chaînes, y compris pour les valeurs nulles
        updatedValues.tjm_vente = this.formconsultant.value.tjm_vente ? this.formconsultant.value.tjm_vente.toString() : '';
        updatedValues.tjm_achat = this.formconsultant.value.tjm_achat ? this.formconsultant.value.tjm_achat.toString() : '';
        updatedValues.salary = this.formconsultant.value.salary ? this.formconsultant.value.salary.toString() : '';
    
        // Patcher le formulaire avec les valeurs mises à jour
        this.formconsultant.patchValue(updatedValues);
    
        // Ne pas supprimer les clés, mais laisser les valeurs vides si null ou "null"
        const cleanedValues = Object.entries(this.formconsultant.value)
          .reduce((acc: any, [key, value]) => {
            acc[key] = value !== null && value !== 'null' ? value : '';
            return acc;
          }, {});
    
          if(this.file){
            cleanedValues.cv = this.file
          } else{
            delete cleanedValues.cv;
          }
          const formData = new FormData();
          Object.entries(cleanedValues).forEach(([key, value]) => {
          if (key === 'cv' && value instanceof Blob) {
              formData.append(key, value);
          } else {
            formData.append(key, String(value ?? ''));
          }
        })
    
        this.esnconsultantservice
          .updateConsultant(
            cleanedValues.candidate_id,
            formData
          )
          .subscribe((res: any) => {
            this.toastrService.success('Consultant a été modifié avec succès');
            this.spinner.hide();
            this.navigateToProfile(this.selectedConsultant.uuid);
    
          }, (error: any) => {
            const message = error?.error?.message || 'Une erreur inattendue s\'est produite.';
            this.toastrService.error(message);
            this.spinner.hide();
          })
      }

      navigateToProfile(consultantUuid: any) {
        this.router.navigate([
          '/candidats/profilecandidatesn',
          consultantUuid,
        ]);
      }

      initializeConsultantForm() {
        if (this.selectedConsultant.cv === 'null') {
          this.isnull = true;
        } else {
          this.isnull = false;
        }
       if(this.selectedConsultant.client_id){
        this.testclient=true
       }
       else{
        this.testclient=false
       }
        this.formconsultant.get('email')?.setValue('');
        this.formconsultant = this.createconsultantForm(this.selectedConsultant);
        const salary = this.formconsultant.get('salary');
        if (salary && this.selectedConsultant && this.selectedConsultant.consultant_e_s_n_s_Salary) {
          salary.setValue(this.selectedConsultant.consultant_e_s_n_s_Salary);
        }
        const tjm_achat = this.formconsultant.get('tjm_achat');
        if (tjm_achat && this.selectedConsultant && this.selectedConsultant.consultant_e_s_n_s_Tjm_achat) {
          tjm_achat.setValue(this.selectedConsultant.consultant_e_s_n_s_Tjm_achat);
        }
        const tjm_vente = this.formconsultant.get('tjm_vente');
        if (tjm_vente && this.selectedConsultant && this.selectedConsultant.consultant_e_s_n_s_Tjm_vente) {
          tjm_vente.setValue(this.selectedConsultant.consultant_e_s_n_s_Tjm_vente);
        }
        this.formconsultant.get('client_id')?.setValue(this.selectedConsultant.client_id?this.selectedConsultant.client_id:this.selectedConsultant.client_id2);
        // this.formconsultant.get('manager_id')?.setValue(this.selectedConsultant.manager_id);
    
    
        if (this.listmanager.length > 0) {
          const manager = this.listmanager.filter( el => el.uuid == this.selectedConsultant.manager_id);
          if (manager) {
            this.formconsultant.get('manager_id')?.setValue(manager[0]?.uuid);            
          }
        }
    
    
        this.formconsultant.get('client_id')?.valueChanges.subscribe((value) => {
          this.clientSelected = !!value;
          if (!this.clientSelected) {
            this.formconsultant.get('mission_start_date')?.disable();
            this.formconsultant.get('mission_end_date')?.disable();
          } else {
            this.formconsultant.get('mission_start_date')?.enable();
            this.formconsultant.get('mission_end_date')?.enable();
          }
        });
    
        this.formconsultant.get('linkedin_link')?.enable();
    
        this.formconsultant.get('mission_start_date')?.enable();
        this.formconsultant.get('mission_end_date')?.enable();
        
        const dateSignature = this.selectedConsultant.consultant_e_s_n[0].date_signature_contrat
        this.formconsultant
          .get('date_signature_contrat')
          ?.setValue(dateSignature? new Date(dateSignature) : null);

         const startDateMission = this.selectedConsultant.consultant_e_s_n_Mission_start_date
        this.formconsultant
          .get('mission_start_date')
          ?.setValue(startDateMission ? new Date(startDateMission) : null);

          const endDateMission = this.selectedConsultant.consultant_e_s_n_Mission_end_date

        this.formconsultant
          .get('mission_end_date')
          ?.setValue(endDateMission? new Date(endDateMission) : null);
          
        this.formconsultant.get('candidate_id')?.setValue(this.selectedConsultant.uuid);
        
      }
}
